import {SubstanceApi} from "@core/api";
import SubstanceList from "@core/domain/substance/SubstanceList";
let lists = [];
let loaded = false;
let promise = null;

function loadSubstanceLists() {
    if (loaded) {
        if (lists.length > 0) {
            return new Promise((resolve) => {
                resolve(lists);
            });
        }
        return promise;
    }
    loaded = true;
    return promise = SubstanceApi
        .lists()
        .then(r => {
            lists = r.data.map(l => {
                return new SubstanceList(l);
            });
            return lists;
        });
}

function getAll() {
    return loadSubstanceLists().then(lists => {
        return lists.map(l => {
            return l;
        })
    });
}

function getSubstanceList(key) {
    return new Promise((resolve, reject) => {
        getAll().then(lists => {
            let list = lists.find(l => l.key === key);

            if (list) {
                resolve(list);
            } else {
                reject('Substance list not found');
            }
        });
    });
}

export {
    getAll,
    getSubstanceList
};
